import { render, staticRenderFns } from "./EMAppBoard.vue?vue&type=template&id=2eec7809&"
import script from "./EMAppBoard.vue?vue&type=script&lang=js&"
export * from "./EMAppBoard.vue?vue&type=script&lang=js&"
import style0 from "./EMAppBoard.vue?vue&type=style&index=0&id=2eec7809&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBadge,VSlideGroup,VSlideItem})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
